import { cn } from '@/lib/utils';

type AppContentProps = {
	children: React.ReactNode;
	className?: string;
};

type AppStackProps = {
	children: React.ReactNode;
	className?: string;
};

type AppSectionProps = {
	children: React.ReactNode;
	className?: string;
};

const AppContent = ({ children, className }: AppContentProps) => {
	return <div className={cn('px-3 py-3', className)}>{children}</div>;
};

const AppStack = ({ children, className }: AppStackProps) => {
	return <div className={cn('space-y-3', className)}>{children}</div>;
};

const AppSection = ({ children, className }: AppSectionProps) => {
	return (
		<section className={cn('rounded-2xl border bg-white p-3 shadow-sm', className)}>
			{children}
		</section>
	);
};

export { AppContent, AppSection, AppStack };
